import { Skeleton } from "@mui/lab";
import { ReactElement, useContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";

import { Collection } from "../../generated/gql/graphql";
import useCollections from "../../hooks/query/collection/use-collections";
import useSharedCollections from "../../hooks/query/collection/use-shared-collections";
import CollectionCard from "../../pages/collection/parts/collection-card/collection-card";
import CollectionList from "../../pages/collection/parts/collection-list/collection-list";
import CollectionListItem from "../../pages/collection/parts/collection-list/collection-list-item";
import CollectionFilter from "../../pages/collection/parts/filter/filter";
import Header from "../../pages/collection/parts/header/header";
import { CollectionsContext } from "../../providers/collections-provider";
import { UserContext } from "../../providers/user-provider";
import { ListLayout } from "../../types/list";
import { parseType } from "../../utils/graphql";

// Bug(john): Sometimes the result is empty but there should be a result.
// Maybe is caused to during the process of concat the two arrays.

export default function CollectionsSearchResult(): ReactElement {
  const [collectionResult, setCollectionResult] = useState<Collection[]>([]);
  const [cookies] = useCookies();

  const { me } = useContext(UserContext);
  const { search } = useContext(CollectionsContext);

  const { data: yourCollectionResult, loading: yourCollectionLoading } =
    useCollections({
      filter: {
        userId: {
          eq: me?.id || "-1",
        },
        name: {
          icontains: search,
        },
      },
    });

  const { data: sharedCollectionResult, loading: sharedCollectionLoading } =
    useSharedCollections(me?.id || "-1", {
      filter: {
        name: {
          icontains: search,
        },
      },
    });

  useEffect(() => {
    if (!yourCollectionResult) {
      return;
    }

    const newCollections = parseType<Collection[]>(
      "collections",
      yourCollectionResult
    );
    setCollectionResult((prev) => {
      const out: Collection[] = [];
      newCollections.map((v) => {
        const item = prev.find((a) => a.id === v.id);
        if (!item) {
          out.push(v);
        }
      });
      return out;
    });
  }, [yourCollectionResult]);

  useEffect(() => {
    if (!sharedCollectionResult) {
      return;
    }

    const newCollections = parseType<Collection[]>(
      "sharedCollections",
      sharedCollectionResult
    );
    setCollectionResult((prev) => {
      const out: Collection[] = [];
      newCollections.map((v) => {
        const item = prev.find((a) => a.id === v.id);
        if (!item) {
          out.push(v);
        }
      });
      return out;
    });
  }, [sharedCollectionResult]);

  if (sharedCollectionLoading || yourCollectionLoading) {
    return (
      <div className="w-full">
        <Header title="Result" amount={0} collection={undefined} />
        <div className="grid gap-[20px] grid-cols-6 w-full">
          {Array.from({ length: 16 }).map((v) => (
            <Skeleton key={`skeleton-${v}`} className="w-full h-[400px]" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <Header
        title="Result"
        amount={collectionResult.length || 0}
        collection={undefined}
      />
      <CollectionFilter />
      <div className="flex gap-20 flex-wrap w-full">
        {cookies.listLayout === ListLayout.Grid ? (
          collectionResult?.map((collection) => (
            <CollectionCard key={collection.id} collection={collection} />
          ))
        ) : (
          <CollectionList>
            {collectionResult?.map((collection) => (
              <CollectionListItem key={collection.id} collection={collection} />
            ))}
          </CollectionList>
        )}
      </div>
    </div>
  );
}
